<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <HowWillPay id="howit" :info="howWillitPay" />
    <BasicRequirement />
    <Outline id="outline" :info="outlineContent" :bgColor="outlineColor" />
    <Certificate :certData="certData" />
    <TestimonialTrainer :info="trainerTestimonial" />
    <TestimonialCompany :info="companyTestimonial" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>

<script>
import TestimonialTrainer from '../components/isaMain/TestimonialTrainer.vue'
import TestimonialCompany from '../components/isaMain/CompanyTestimonial.vue'
import Landing from '../components/isaMain/Landing.vue'
import AboutInstructor from '../components/isaMain/AboutInstructor.vue'
import ProgramInfo from '../components/isaMain/ProgramInfo.vue'
import HowWillPay from '../components/isaMain/HowWillPay.vue'
import Contact from '../components/isaMain/Contact.vue'
import Certificate from '../components/isaMain/Certificate.vue'
import BasicRequirement from '../components/isaMain/BasicRequirement.vue'
import Outline from '../components/isaMain/Outline.vue'

import Faq from '../components/isaMain/Faq.vue'
export default {
  data() {
    return {
      landingData: {
        title: 'Your first step towards a Financial Analyst Position',
        paragraph:
          'Upskill presents a thorough bootcamp only designed for junior to mid level Financial analysts/managers.Take part in this bootcamp, and get a chance to work at CMED, an IoT enabled AI driven cloud based smart medical platform for primary and preventive healthcare. Salary range will be 50k-100k based on work experience.You will be taught by Fayaz Taher',
        companyLogo: require('../assets/cmed/cmed-logo.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        landingImage: require('../assets/cmed/cmed-instuctor.png'),
      },
      instructorData: {
        name: 'Fayaz Taher',
        avatar: require('../assets/cmed/fayaz_bhai_avatar.png'),
        info:
          'Fayaz is a serial entrepreneur, investor, mentor and a startup community advocate from Bangladesh. Fayaz co-founded Startup Dhaka and Magnito digital. He also is a director at Fortuna Group that has investments in various sectors including life insurance, insurance, food and leather. Currently he is working as COO of the largest streaming services in Bangladesh.',
        designation: '',

        additionalInfo:
          'Fayaz is currently in the role of Chief of Operating Officer at Bongo which is the largest Video platform and Multichannel network in Bangladesh.Fayaz was the CEO of Fortuna and managing all aspects of the business including marketing, production, development, financial forecasting, material sourcing, and digitizing way of work in the company. Managing multiple teams cross border with offices in China and Bangladesh.Director of IBT, which was announced as one of the winners of the FbFund in 2008 in social gaming. Helped reached over 1 million users and daily monetization. IBT was also a tech partner in socialbuy.com which was sold to kbgdeals.Co-Founder at Startup Dhaka which is a platform for startups and investors in Bangladesh which operated the Grameenphone Accelerator, launched a new pitching show called Tiger Cage, and an education platform called Upskill in Bangladesh. Working as a in-house mentor as well as mentor to tech other startups.He has undergraduate degree from Babson College in USA and Masters Degree from Clark University in USA.Specialties: Financial budgeting & Costing, Strategic Planning, Investment Decisions,Operations, Sourcing, Marketing, Advertising, Conceptual Design',
        bgColor: '#EA4424',
      },
      programData: {
        headingInfo:
          'Financial Analyst bootcamp consists of approximately 4 hours of material delivered over a period of 5 weeks. To participate in this Bootcamp, you are required to pass an assessment test with minimum 60% of the total score.',
        seatsInfo:
          'The bootcamp will only have 20 seats. It’s on a first come first served basis. Take the quiz today to secure your spot.. ',
        lenth: '5 weeks',
        startDate: '15th Jan,2022',
        cost: 'BDT 8000**',
        deadline: '10th Jan,2022',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        discountInfo:
          '** If you take the quiz by 31st Dec, you’ll avail a 10% discount course fee.',
        jobOppurtunity:
          'If you are one of the top 5 students by the end of 6 weeks, you will get to interview at CMED for the Financial Analyst position. So, don’t miss the offer as the seats are limited!',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#EA4424',
      },
      certData: {
        certImage: require('../assets/cmed/CMED.png'),
        bgCert: require('../assets/cmed/Rectangle.png'),
      },
      trainerTestimonial: {
        mainImg: require('../assets/cmed/trainer.png'),
        name: 'M Fayaz Taher',
        paragraph:
          'This program should help a Financial analysts to learn how to aggregate a large amount of financial data and help in providing decision-makers with the information they need to increase revenue, prepare investor reporting and manage assets successfully.',
        designation: '',
      },
      companyTestimonial: {
        mainImg: require('../assets/cmed/WhatsApp Image 2021-12-19 at 5.01.59 PM.png'),
        name: 'Dr. Khondaker A. Mamun',
        paragraph:
          'As an award winning health care startup, we are looking for a passionate financial analyst who can help us navigate financial reporting, investor updates, financial modelling etc. so we are compliant and always up to date',
        designation: 'Founder & Chairman',
        invertedCommaBg: '',
      },
      basicRequirement: {
        mainContent: [],
        bgColor: '',
      },
      howWillitPay: {
        numericalColor: '#1EBCE5',
        stepsTextColor: '#EA4424',
        steps: [],
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        companyName: 'CMED',
      },
      outlineContent: [
        {
          classNumber: 'Class 1',
          classSub: 'Basics  of the Role',
          orderList: [
            ' Understanding the Role?  ',
            'What is the function of the Finance Department?',
            'What is the difference between Controller/Analyst?  ',
            'What key statements are important for Startups? Why?',
          ],
        },
        {
          classNumber: 'Class 2',
          classSub: 'Financial Data',
          orderList: [
            ' Organising the Data ',
            'Importance of the Accuracy of Data',
            'Importance of Contractual Agreements – Income and Expenses ',
            'Speed of accessing data and distributing – Why does that matter?',
            'Cash flow data vs P&L? Fundamental Differences ',
          ],
        },
        {
          classNumber: 'Class 3',
          classSub: 'Preparing the Data into Actionable Reports ',
          orderList: [
            'P&L',
            'Cash Flow',
            'Statement of Startup Costs ',
            'Sources / Uses ',
            'Balance Sheet ',
          ],
        },

        {
          classNumber: 'Class 4',
          classSub: 'Forecasting and Analysis  ',
          orderList: [
            'Why is it important to forecast?',
            'Cash Flow Forecast',
            'P&L Forecast',
            'HR Forecast',
            'Tech Forecast',
            'Unit Metrics Understanding',
            'Cash Flow contribution by Department',
            'Forecast by Department',
          ],
        },
        {
          classNumber: 'Class 5',
          classSub: 'Reporting Formal and Informal ',

          orderList: [
            'Management Pack',
            'Board Pack',
            'Data Room for Investors',
            'Company Town Hall – What info to share and what not?',
            'Departmental Performance Reports',
            'Quarterly Reports',
          ],
        },
      ],
      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the course?\n',
          content: '5 Weeks.\n',
          category: 'FAQ',
        },
        {
          title: 'What is the bootcamp fee?\n',
          content: '8000  BDT Per person',
          category: 'FAQ',
        },
        {
          title: 'What is the mode of payment? \n',
          content: 'We offer Bkash or Bank Payee Check \n',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Yes, a minimum of 2+ years of experience in financial & managerial accounting.',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify? \n',
          content: '60% of the total score  i.e. 6 out of 10 \n',
          category: 'FAQ',
        },
        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.',
          category: 'FAQ',
        },
        // {
        //   title: 'What are the materials that will be available?\n',
        //   content:
        //     'You’ll get recorded videos and reading materials every week. Hands on Workshops with the instructor himself for 2.5 hours each week.\n',
        //   category: 'FAQ',
        // },
        // {
        //   title: 'Will I have lifetime access to the videos?\n',
        //   content:
        //     'Yes, if you get enrolled in the bootcamp, and continue till the certification you will have lifetime access to the videos. \n',
        //   category: 'FAQ',
        // },
        // {
        //   title: 'Do I need to make appointments beforehand with the TA’s?\n',
        //   content:
        //     'Yes, you do. They will be available every Thursday night for 1-1.5hours to answer all your queries regarding the weekly content. \n',
        //   category: 'FAQ',
        // },
        {
          title: 'How will the top 5 be assessed?\n',
          content:
            'There will be an assessment test by the end of the bootcamp, and a weekly performance track will also be kept to evaluate each students’ position. \n',
          category: 'FAQ',
        },
        {
          title: 'Will everyone get a chance to interview at CMED?\n',
          content:
            'No, the top 5 students will get a chance to interview at CMED, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    ProgramInfo,
    Contact,
    Certificate,
    TestimonialTrainer,
    TestimonialCompany,
    HowWillPay,
    BasicRequirement,
    Outline,
    Faq,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
